export let ScreenWithShadowVolumesPassTypeName: string  = "ScreenWithShadowVolumes";
export let ScreenPassTypeName: string = "Screen";
export let ScreenPassAllOpaqueTypeName: string = "ScreenAllOpaque";
export let ScreenPassAllTransparentTypeName: string = "ScreenAllTransparentOpaque";
export let WeightedAverageTransparencyPassTypeName: string = "WeightedAverageTransparency";
export let DepthLowResPassTypeName: string = "DepthLowRes";
export let ObjectIdPassTypeName: string = "ObjectId";
export let PrimitiveIdPassTypeName: string = "PrimitiveId";
export let DepthPassTypeName: string = "Depth";